import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="partner_content">
              <h2>Partner Up With the Right Web3 Development Company</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Choose the perfect partner for your project – a professional web
              3.0 development company that understands the intricate balance
              between innovation, security, and user experience. Our Web3
              development services ensure customized solutions. Here are our
              achievements in the domain of Web3 app development:
            </p>
          </Col>
        </Row>
        <Row className="h-100 partner_padd">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on Clutch</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">5.0</div>
            <div className="partner-para">
              <p>Average Review Rating on GoodFirms</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on RightFirms</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Partner;
